import { render, staticRenderFns } from "./create-agent.vue?vue&type=template&id=68b65c86&scoped=true"
import script from "./create-agent.vue?vue&type=script&lang=js"
export * from "./create-agent.vue?vue&type=script&lang=js"
import style0 from "./create-agent.vue?vue&type=style&index=0&id=68b65c86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b65c86",
  null
  
)

export default component.exports